import { useState,useEffect } from "react";
import { FileChartColumn } from "lucide-react";
import { FiUsers, FiBook, FiClipboard, FiBarChart2, FiBookOpen, FiFeather, FiTool, FiActivity, FiBriefcase, FiHome } from "react-icons/fi";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ResearcherDashboard = () => {
 const [data, setData] = useState(null);
//  console.log('The data is:',data)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/researcher/researcher-status/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        setData(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const cards = [
  {
    id: 1,
    title: "Total Publications",
    value: data?.total,
    icon: <FiBookOpen className="text-xl" />,
  },
  {
    id: 2,
    title: "Theoretical Ideas",
    value: data?.theoreticalideas,
    icon: <FiFeather className="text-xl" />,
  },
  {
    id: 3,
    title: "Prototypes",
    value: data?.prototypes,
    icon: <FiTool className="text-xl" />,
  },
  {
    id: 4,
    title: "Lab Experiments",
    value: data?.labexperiments,
    icon: <FiActivity className="text-xl" />,
  },
  {
    id: 5,
    title: "Industrial Applications",
    value: data?.industrialapplications,
    icon: <FiBriefcase className="text-xl" />,
  },
  {
    id: 6,
    title: "Lab Spaces",
    value: 5,
    icon: <FiHome className="text-xl" />,
  },
   {
    id: 6,
    title: "Opportunities",
    value: data?.opportunities,
    icon: <FileChartColumn className="text-xl" />,
  },
];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.id}
          className="flex items-center min-h-[100px] p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-all"
        >
          <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <div className="text-[#0f6abf]">
              {card.icon}
            </div>
          </div>
          <div className="ml-4">
            <h1 className="text-sm font-medium text-gray-600">{card.title}</h1>
            <p className="text-xl font-semibold text-gray-900">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResearcherDashboard;




